import {takeEvery} from 'redux-saga/effects';
import {toast} from 'react-toastify';

import {TYPES as CURRENT_USER_TYPE} from '../creators/currentUser';

export function fetchSuccess(action) {
    let message = {
        [CURRENT_USER_TYPE.UPDATE_SUCCESS] : "Profil mis à jour !",

        USER_EMAIL_UPDATE_SUCCESS : "Email mis à jour !",
        USER_PASSWORD_UPDATE_SUCCESS : "Mot de passe mis à jour !",

        USER_STATUS_CREATE_SUCCESS : "Statut publié !",
        USER_STATUS_UPDATE_SUCCESS : "Statut publié !",
        USER_STATUS_DELETE_SUCCESS : "Statut supprimé !",

        USER_ALBUM_CREATE_SUCCESS : "Album créé !",
        USER_ALBUM_UPDATE_SUCCESS : "Album mis à jour !",
        USER_ALBUM_DELETE_SUCCESS : "Album supprimé !",

        STORY_CREATE_SUCCESS: "Histoire en attente de validation",
        STORY_DELETE_SUCCESS: "Histoire supprimée !",

        ARTICLE_CREATE_SUCCESS: "Article créé !",
        ARTICLE_UPDATE_SUCCESS: "Article sauvegardé !",
        ARTICLE_DELETE_SUCCESS: "Article supprimé !",

        FORUM_TOPIC_CREATE_SUCCESS: "Topic créé !",
        FORUM_TOPIC_UPDATE_SUCCESS: "Topic sauvegardé !",
        FORUM_TOPIC_DELETE_SUCCESS: "Topic supprimé !",

        FORUM_COMMENT_CREATE_SUCCESS: "Réponse créée !",
        FORUM_COMMENT_UPDATE_SUCCESS: "Réponse sauvegardée !",
        FORUM_COMMENT_DELETE_SUCCESS: "Réponse supprimé !",

        ALBUM_MEDIA_CREATE_SUCCESS: "Media envoyé !",

        REPORT_CREATE_SUCCESS: "Votre signalement a bien été envoyé !",

        MEDIA_UPDATE_SUCCESS: "Media mis à jour !",
        MEDIA_DELETE_SUCCESS: "Media supprimé !",
    };
    toast(message[action.type],{
        className: 'toast-background toast-success',
        bodyClassName: "toast-font toast-success",
        progressClassName: 'toast-loader toast-success'
    });
}

export function fetchError(action) {
    let statusCode = action.error.response.statusCode;
    let message = {
        [CURRENT_USER_TYPE.UPDATE_FAIL]: "Impossible de mettre votre profil à jour",

        USER_EMAIL_UPDATE_FAIL: statusCode === 401 ? "Mot de passe incorrect" : "Impossible de mettre votre Email à jour",
        USER_PASSWORD_UPDATE_FAIL: statusCode === 401 ? "Mot de passe incorrect" : "Impossible de mettre votre mot de passe à jour",

        USER_STATUS_CREATE_FAIL: "Un problème est survenu lors de la publication de votre statut. Veuillez réessayer",
        USER_STATUS_UPDATE_FAIL: "Un problème est survenu lors de la mis à jour de votre statut. Veuillez réessayer",
        USER_STATUS_DELETE_FAIL: "Un problème est survenu lors de la suppression de votre statut. Veuillez réessayer",

        USER_ALBUM_CREATE_FAIL: "Un problème est survenu lors de la création de votre album. Veuillez réessayer",
        USER_ALBUM_UPDATE_FAIL: "Un problème est survenu lors de la mis à jour de votre album. Veuillez réessayer",
        USER_ALBUM_DELETE_FAIL: "Un problème est survenu lors de la suppression de votre album. Veuillez réessayer",

        STORY_CREATE_FAIL: "Un problème est survenu lors de la publication de votre histoire. Veuillez réessayer",
        STORY_DELETE_FAIL: "Un problème est survenu lors de la suppression de votre histoire. Veuillez réessayer",

        ARTICLE_CREATE_FAIL: "Un problème est survenu lors de la création de votre article. Veuillez réessayer",
        ARTICLE_UPDATE_FAIL: "Un problème est survenu lors de la sauvegarde de votre article. Veuillez réessayer",
        ARTICLE_DELETE_FAIL: "Un problème est survenu lors de la suppression de votre article. Veuillez réessayer",

        FORUM_TOPIC_CREATE_FAIL: "Un problème est survenu lors de la création de votre topic. Veuillez réessayer",
        FORUM_TOPIC_UPDATE_FAIL: "Un problème est survenu lors de la sauvegarde de votre topic. Veuillez réessayer",
        FORUM_TOPIC_DELETE_FAIL: "Un problème est survenu lors de la suppression de votre topic. Veuillez réessayer",

        FORUM_COMMENT_CREATE_FAIL: "Un problème est survenu lors de la création de votre réponse. Veuillez réessayer",
        FORUM_COMMENT_UPDATE_FAIL: "Un problème est survenu lors de la sauvegarde de votre réponse. Veuillez réessayer",
        FORUM_COMMENT_DELETE_FAIL: "Un problème est survenu lors de la suppression de votre réponse. Veuillez réessayer",

        ALBUM_MEDIA_CREATE_FAIL: "Un problème est survenu lors de l'envoie de media",

        REPORT_CREATE_FAIL: "Un problème est survenu lors de l'envoie de votre signalement",

        MEDIA_UPDATE_FAIL: "Un problème est survenu lors de la mis à jour du media",
        MEDIA_DELETE_FAIL: "Un problème est survenu lors de la suppresion du media",
    };

    toast(message[action.type],{
        autoClose: 10000,
        className: 'toast-background toast-error',
        bodyClassName: "toast-font toast-error",
        progressClassName: 'toast-loader toast-error'
    });
}

export function* watchToastifyNotification() {
    yield takeEvery([[CURRENT_USER_TYPE.UPDATE_SUCCESS],

                            "USER_EMAIL_UPDATE_SUCCESS",
                            "USER_PASSWORD_UPDATE_SUCCESS",

                            "USER_STATUS_CREATE_SUCCESS",
                            "USER_STATUS_UPDATE_SUCCESS",
                            "USER_STATUS_DELETE_SUCCESS",

                            "USER_ALBUM_CREATE_SUCCESS",
                            "USER_ALBUM_UPDATE_SUCCESS",
                            "USER_ALBUM_DELETE_SUCCESS",

                            "STORY_CREATE_SUCCESS",
                            "STORY_DELETE_SUCCESS",

                            "ARTICLE_CREATE_SUCCESS",
                            "ARTICLE_UPDATE_SUCCESS",
                            "ARTICLE_DELETE_SUCCESS",

                            "FORUM_TOPIC_CREATE_SUCCESS",
                            "FORUM_TOPIC_UPDATE_SUCCESS",
                            "FORUM_TOPIC_DELETE_SUCCESS",

                            "FORUM_COMMENT_CREATE_SUCCESS",
                            "FORUM_COMMENT_UPDATE_SUCCESS",
                            "FORUM_COMMENT_DELETE_SUCCESS",

                            "ALBUM_MEDIA_CREATE_SUCCESS",

                            "REPORT_CREATE_SUCCESS",

                            "MEDIA_UPDATE_SUCCESS",
                            "MEDIA_DELETE_SUCCESS",
        ], fetchSuccess);

    yield takeEvery([[CURRENT_USER_TYPE.UPDATE_FAIL],

                            "USER_EMAIL_UPDATE_FAIL",
                            "USER_PASSWORD_UPDATE_FAIL",

                            "USER_STATUS_CREATE_FAIL",
                            "USER_STATUS_UPDATE_FAIL",
                            "USER_STATUS_DELETE_FAIL",

                            "USER_ALBUM_CREATE_FAIL",
                            "USER_ALBUM_UPDATE_FAIL",
                            "USER_ALBUM_DELETE_FAIL",

                            "STORY_CREATE_FAIL",
                            "STORY_DELETE_FAIL",

                            "ARTICLE_CREATE_FAIL",
                            "ARTICLE_UPDATE_FAIL",
                            "ARTICLE_DELETE_FAIL",

                            "FORUM_TOPIC_CREATE_FAIL",
                            "FORUM_TOPIC_UPDATE_FAIL",
                            "FORUM_TOPIC_DELETE_FAIL",

                            "FORUM_COMMENT_CREATE_FAIL",
                            "FORUM_COMMENT_UPDATE_FAIL",
                            "FORUM_COMMENT_DELETE_FAIL",

                            "ALBUM_MEDIA_CREATE_FAIL",

                            "REPORT_CREATE_FAIL",

                            "MEDIA_UPDATE_FAIL",
                            "MEDIA_DELETE_FAIL",
        ], fetchError);
}

export default watchToastifyNotification;
